var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoCustomers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 299,
    height: 221,
    viewBox: "0 0 299 221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "169.961%",
    x2: "38.532%",
    y1: "-324.054%",
    y2: "125.543%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#44C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B9F9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("circle", {
    id: "b",
    cx: 7.089,
    cy: 7.089,
    r: 7.089
  }), /*#__PURE__*/React.createElement("circle", {
    id: "d",
    cx: 14.492,
    cy: 14.492,
    r: 14.492
  }), /*#__PURE__*/React.createElement("circle", {
    id: "f",
    cx: 7.089,
    cy: 7.089,
    r: 7.089
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1-40h300v300H-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M265.255 151.742C264.59 212.197 215.41 261 154.842 261 93.86 261 44.423 211.527 44.423 150.5c0-5.053.34-10.026.995-14.899H10.933c-5.486 0-9.933-4.447-9.933-9.932 0-5.486 4.447-9.933 9.933-9.933h78.146c5.486 0 9.933-4.447 9.933-9.933a9.936 9.936 0 0 0-6.468-9.311 9.912 9.912 0 0 1-3.464.62H43.19c-5.486 0-9.933-4.447-9.933-9.932 0-5.486 4.447-9.933 9.933-9.933H72.17C92.401 54.401 121.941 40 154.842 40c47.457 0 87.921 29.96 103.537 72.011h31.688c5.486 0 9.933 4.447 9.933 9.933 0 5.485-4.447 9.932-9.933 9.932h-48.371c-5.486 0-9.933 4.447-9.933 9.933s4.447 9.933 9.933 9.933h23.559z",
    transform: "translate(-1 -40)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#80959D",
    d: "M207 187.882a4.121 4.121 0 0 1-4.125 4.118h-90.75a4.121 4.121 0 0 1-4.125-4.118V70.119A4.122 4.122 0 0 1 112.126 66h90.75A4.122 4.122 0 0 1 207 70.119v117.763zM155.916 71.269a1.588 1.588 0 1 0 3.17 0 1.584 1.584 0 0 0-1.585-1.546c-.86 0-1.565.686-1.585 1.546z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#80959D",
    d: "M112 77h92v106h-92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB8181",
    fillRule: "nonzero",
    d: "M112 90h92V77h-92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M115.864 87h85.272c.477 0 .864-.38.864-.85v-6.3c0-.47-.387-.85-.864-.85h-85.272a.857.857 0 0 0-.864.85v6.3c0 .47.387.85.864.85z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#64808C",
    strokeWidth: 0.5,
    transform: "translate(196 81)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M3 3l1 1"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 7.089,
    cy: 7.089,
    r: 7.089,
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#F7ADAD",
    transform: "translate(123 99)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(123 99)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("use", {
    stroke: "#87D5FA",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#87D5FA",
    fillRule: "nonzero",
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.089 9.337a2.94 2.94 0 0 0 0-5.88 2.94 2.94 0 0 0 0 5.88zm5.34 2.614a4.594 4.594 0 0 0-.3-.577c-.601-.914-1.543-1.533-2.596-1.688a.529.529 0 0 0-.382.098 3.146 3.146 0 0 1-1.887.634 3.146 3.146 0 0 1-1.885-.634.529.529 0 0 0-.382-.098A3.741 3.741 0 0 0 2.1 11.951a.274.274 0 0 0 .013.253c.11.182.232.38.356.549.177.253.382.492.6.703.192.197.398.366.616.535a5.82 5.82 0 0 0 3.58 1.223 5.82 5.82 0 0 0 3.58-1.223c.214-.168.42-.346.615-.535.219-.212.424-.45.6-.703.124-.17.247-.352.356-.55a.326.326 0 0 0 .014-.252z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#BEBFBA",
    fillRule: "nonzero",
    d: "M150 149.162V149h.037l-.037.162"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.492,
    cy: 14.492,
    r: 14.492,
    fill: "#FFF",
    fillRule: "nonzero",
    transform: "translate(115 122)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(115 122)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#EB8181",
    fillRule: "nonzero",
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.492 19.087a6.01 6.01 0 0 0 6.01-6.009 6.01 6.01 0 0 0-6.01-6.008 6.01 6.01 0 0 0-6.01 6.008 6.01 6.01 0 0 0 6.01 6.01zm10.919 5.345a9.208 9.208 0 0 0-.615-1.178c-1.229-1.87-3.156-3.136-5.307-3.452a1.08 1.08 0 0 0-.782.201 6.431 6.431 0 0 1-3.855 1.294 6.431 6.431 0 0 1-3.856-1.294 1.084 1.084 0 0 0-.782-.202c-2.15.316-4.077 1.554-5.308 3.453a6.745 6.745 0 0 0-.614 1.178.562.562 0 0 0 .028.519c.223.373.475.776.727 1.12a9.965 9.965 0 0 0 1.228 1.44c.391.402.81.746 1.257 1.092a11.897 11.897 0 0 0 7.32 2.503c2.654 0 5.196-.863 7.319-2.503.446-.345.866-.72 1.257-1.093.454-.44.866-.92 1.229-1.438.251-.345.503-.719.726-1.121a.668.668 0 0 0 .028-.519z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#80959D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.34 125.183c5.407-5.408 14.205-5.408 19.613 0 5.407 5.408 5.407 14.206 0 19.614-5.407 5.407-14.205 5.407-19.613 0-5.408-5.408-5.408-14.205 0-19.614zm-3.321 20.271l-3.12 3.12 2.663 2.663 3.12-3.12c6.586 5.258 16.24 4.842 22.337-1.254 6.547-6.547 6.547-17.199 0-23.745-6.547-6.547-17.199-6.547-23.745 0-6.097 6.096-6.513 15.75-1.255 22.336z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.977 167.161l19.595-19.593a1.719 1.719 0 0 1 2.43 0l2.709 2.708a1.719 1.719 0 0 1 0 2.43L97.117 172.3a1.719 1.719 0 0 1-2.431 0l-2.709-2.707a1.719 1.719 0 0 1 0-2.432z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 7.089,
    cy: 7.089,
    r: 7.089,
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#F7ADAD",
    transform: "translate(123 157)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(123 157)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f"
  })), /*#__PURE__*/React.createElement("use", {
    stroke: "#87D5FA",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#87D5FA",
    fillRule: "nonzero",
    mask: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.089 9.337a2.94 2.94 0 0 0 0-5.88 2.94 2.94 0 0 0 0 5.88zm5.34 2.614a4.594 4.594 0 0 0-.3-.577c-.601-.914-1.543-1.533-2.596-1.688a.529.529 0 0 0-.382.098 3.146 3.146 0 0 1-1.887.634 3.146 3.146 0 0 1-1.885-.634.529.529 0 0 0-.382-.098A3.741 3.741 0 0 0 2.1 11.951a.274.274 0 0 0 .013.253c.11.182.232.38.356.549.177.253.382.492.6.703.192.197.398.366.616.535a5.82 5.82 0 0 0 3.58 1.223 5.82 5.82 0 0 0 3.58-1.223c.214-.168.42-.346.615-.535.219-.212.424-.45.6-.703.124-.17.247-.352.356-.55a.326.326 0 0 0 .014-.252z"
  }))), /*#__PURE__*/React.createElement("path", {
    stroke: "#80959D",
    strokeLinecap: "square",
    strokeWidth: 2,
    d: "M149.5 100.5h23M149.5 134.5h23M149.5 159.5h23"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#80959D",
    strokeLinecap: "square",
    d: "M149.5 105.5h39M149.5 139.5h39M149.5 164.5h39M149.5 110.5h39M149.5 144.5h39M149.5 169.5h39"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCustomers);
export default __webpack_public_path__ + "static/media/no-customers.9a42f6201133e0be715df2b652174faf.svg";
export { ForwardRef as ReactComponent };